import { AtsRecordType } from "./../../functions/functions/src/types"

export const getTotalGamesFromLock = (l?: AtsRecordType) => {
    if (!l) return 0
    return l.record.split("-").reduce((acc, v) => parseInt(v) + acc, 0)
}
